<template>

    <el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="left">
      <div>上左</div>
    </el-tooltip>
</template>

<script>
import { parseColomnShow } from '../providers/store-parser'
export default {
  name: 'ColumnProductCodePopover',
  props: {
    rowId: {
      type: [Number, String],
      required: true
    },
    row: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    getter: {
      type: String,
      required: true
    },
    trans: {
      type: String,
      required: true
    },
    labelClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    value () {
      return parseColomnShow(this.row, this.getter, this.trans)
    }
  }
}
</script>
<style lang="scss" scoped>
.item-name {
  font-weight: bold;
}
</style>
